import { LOGIN, LOGOUT } from './actions_types'
import { SET_AUTH, RESET_AUTH, CLEAR_SESSION } from './mutations_types'
import { api } from '../plugins/axios_settings'
import cookie from 'vue-cookie'

const state = {
  isAuthenticated: false,
  showLoader: false,
  authToken: '',
  userDetails: {},
  isLoggedIn: false
}

const getters = {
  getuserDetails (state) {
    return state.userDetails
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  }
}

const mutations = {
  [SET_AUTH] (state, data) {
    state.userDetails = data.user
    state.authToken = data.authToken
    state.isAuthenticated = true
  },
  [RESET_AUTH] (state) {
    state.isAuthenticated = false
    state.authToken = null
    state.userDetails = {}
  },
  [CLEAR_SESSION] (state) {
    state.isAuthenticated = false
  }
}

const actions = {
  [LOGIN] (context, model) {
    return new Promise((resolve, reject) => {
      api.post('auth', model).then(response => {
        var date = new Date()
        date.setDate(date.getDate() + 4)
        // eslint-disable-next-line camelcase
        let { id, name, token, email, username } = response.data
        let user = JSON.stringify({ id, name, email, username })
        cookie.set(process.env.VUE_APP_TOKEN, token, { expires: date })
        cookie.set(process.env.VUE_APP_USER, user, { SameSite: 'Strict' })
        context.commit(SET_AUTH, { authToken: token, user: JSON.parse(user) })
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  [LOGOUT] ({ commit }) {
    cookie.delete(process.env.VUE_APP_TOKEN)
    cookie.delete(process.env.VUE_APP_USER)
    commit(RESET_AUTH)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
